import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const CTAButtonWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    '& .cta-button': {
        padding: theme.spacing(1.5, 4),
        fontSize: '1rem',
        fontWeight: theme.typography.fontWeightMedium,
        borderRadius: theme.spacing(2),
        textTransform: 'none',
        boxShadow: theme.shadows[4],
        transition: 'all 0.3s ease',
        '&:hover': {
            boxShadow: theme.shadows[8],
            transform: 'translateY(-2px)',
        },
        '& .MuiButton-endIcon': {
            marginLeft: theme.spacing(1),
            transition: 'transform 0.3s ease',
        },
        '&:hover .MuiButton-endIcon': {
            transform: 'translateY(4px)',
        },
    },
}));

/**
 * ScrollToSectionButton Component
 * 
 * A reusable CTA button that scrolls to a target section when clicked.
 * 
 * @param {Object} props
 * @param {Function} props.onClick - Scroll handler function (usually from useScrollToSection hook)
 * @param {string} props.text - Button text (default: 'Get Started')
 * @param {string} props.variant - Button variant (default: 'contained')
 * @param {string} props.color - Button color (default: 'primary')
 * @param {string} props.size - Button size (default: 'large')
 * @param {boolean} props.showArrow - Show arrow icon (default: true)
 * @param {Object} props.sx - Additional sx styles
 * @param {Object} props.buttonProps - Additional props to pass to Button
 */
export const ScrollToSectionButton = ({
    onClick,
    text = 'Get Started',
    variant = 'contained',
    color = 'primary',
    size = 'large',
    showArrow = true,
    sx,
    ...buttonProps
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <CTAButtonWrapper sx={sx}>
            <Button
                variant={variant}
                color={color}
                size={size}
                onClick={handleClick}
                endIcon={showArrow ? <ArrowDownwardIcon /> : null}
                className="cta-button"
                {...buttonProps}
            >
                {text}
            </Button>
        </CTAButtonWrapper>
    );
};

